module.exports = __webpack_public_path__ + "static/media/rnl-logo.271527ae.png";